import { Icon } from "@iconify/react";
import {
  useCreateUserWithEmailAndPassword,
  useSignInWithEmailAndPassword,
  useSignInWithGoogle,
} from "react-firebase-hooks/auth";
import { Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import auth from "../firebase/auth";
import useToken from "../hooks/useToken";
import FirebaseError from "./FirebaseError";
import SpinnerBorder from "./SpinnerBorder";
import SpinnerDot from "./SpinnerDot";

export default function AuthArea({ Form }) {
  const location = useLocation(),
    from = location?.state?.from?.pathname;

  const [signInWithGoogle, googleUser, signingInWithGoogle, googleSignInError] =
    useSignInWithGoogle(auth);

  const [
    createUserWithEmailAndPassword,
    newPasswordUser,
    creatingUserWithEmailAndPassword,
    accountCreationError,
  ] = useCreateUserWithEmailAndPassword(auth);

  const [
    signInWithEmailAndPassword,
    passwordUser,
    signingInWithEmailAndPassword,
    emailAndPasswordSignInError,
  ] = useSignInWithEmailAndPassword(auth);

  const [token, generatingToken] = useToken(
    googleUser || newPasswordUser || passwordUser
  );

  if (generatingToken) {
    return (
      <div className="p-4 pt-8">
        <SpinnerDot />
      </div>
    );
  }

  if (token) {
    return <Navigate to={from || "/dashboard"} replace />;
  }

  if (localStorage.getItem("token")) {
    return <Navigate to={"/dashboard"} replace />;
  }

  return (
    <main>
      <div class="bg-base-200 p-12">
        <div class="text-center gap-4 flex flex-col">
          <Form
            createUserWithEmailAndPassword={createUserWithEmailAndPassword}
            creatingUserWithEmailAndPassword={creatingUserWithEmailAndPassword}
            accountCreationError={accountCreationError}
            signInWithEmailAndPassword={signInWithEmailAndPassword}
            signingInWithEmailAndPassword={signingInWithEmailAndPassword}
            emailAndPasswordSignInError={emailAndPasswordSignInError}
          />

          <div class="divider my-4">Or</div>

          <button
            onClick={() => {
              signInWithGoogle();
            }}
            className="px-5 btn btn-primary d-flex gap-2 mx-auto align-items-center"
          >
            {signingInWithGoogle ? (
              <SpinnerBorder />
            ) : (
              <>
                <Icon icon="flat-color-icons:google" />
                Sign in Using Google
              </>
            )}
          </button>

          {googleSignInError && <FirebaseError error={googleSignInError} />}
        </div>
      </div>
    </main>
  );
}
